import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import LoadingCube from "sub_components/Common/LoadingCube";
import { NotFound } from "pages/NotFound";
/** v3 imports */
import { Library } from "pages/Library/Library";
import ProtectedRoute from "routing/ProtectedRoute";
import rootReducer from "reducers";
import "stylesheets/main.scss";
import { thunk } from "redux-thunk";
import App from "App";
import TagManager from "react-gtm-module";
import { LoginPageWrapper } from "pages/Login/LoginPageWrapper";
import ErrorBoundary from "pages/ErrorBoundary";
import Hotjar from "@hotjar/browser";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const HOTJAR_VERSION = process.env.REACT_APP_HOTJAR_VERSION;
const HOTJAR_SITE_ID = process.env.REACT_APP_HOTJAR_SITE_ID;

const PasswordRegistrationWrapper = lazy(() =>
  import("pages/Login/PasswordRegistrationWrapper")
);

const Sandbox = lazy(() => import("pages/Sandbox/Sandbox"));
const Sandbox2 = lazy(() => import("pages/Sandbox/Sandbox2"));

const tagManagerArgs = {
  gtmId: "GTM-NJBQV57",
};
const environment = process.env.NODE_ENV;

const app = document.getElementById("root");

// create a root
const root = createRoot(app);
Hotjar.init(HOTJAR_SITE_ID, HOTJAR_VERSION);
TagManager.initialize(tagManagerArgs);

const store = createStore(rootReducer, applyMiddleware(thunk));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App>
        <Suspense fallback={<LoadingCube />}>
          <ErrorBoundary>
            <Routes>
              <Route path="*" element={<NotFound />} />
              <Route path="/login" element={<LoginPageWrapper />} />
              <Route
                path="/passwordRegistration"
                element={<PasswordRegistrationWrapper />}
              >
                <Route path=":code" element={<PasswordRegistrationWrapper />} />
              </Route>
              <Route path="/portal/*" element={<ProtectedRoute />} />
              <Route path="/" element={<LoginPageWrapper />} />
              <Route path="/sandbox" element={<Sandbox />} />
              {environment !== "production" && (
                <Route path="/library/*" element={<Library />} />
              )}
              <Route path="/sandbox2" element={<Sandbox2 />} />
            </Routes>
          </ErrorBoundary>
        </Suspense>
      </App>
    </BrowserRouter>
  </Provider>
);
serviceWorkerRegistration.register();
